"use client"

import Script from "next/script"
import { usePathname } from "next/navigation"

/** Routes where we never load third-party tracking: the guided workspace handles sensitive incident details. */
const NO_TRACKING = [/^\/start/, /^\/incident/]

export function HubspotLoader() {
  const path = usePathname() ?? ""
  if (NO_TRACKING.some((r) => r.test(path))) return null
  return <Script id="hs-script-loader" src="//js.hs-scripts.com/47453230.js" strategy="afterInteractive" />
}
